'use strict';

const i18n = require('i18next');
const Mn = require('backbone.marionette');
const SidebarView = require('common/ui/view/sidebar/index');
const SidebarCollection = require('common/ui/view/sidebar/collection');
const Key = require('common/domain/value/key');
const RelatedKeys = require('common/domain/value/related-keys');
const ContentTemplate = require('balus/ui/template/body/data-content/index.hbs');
const CommentCollectionRepository = require('communication/domain/repository/comment-collection');
const CoverView = require('balus/ui/view/body/project/cover');
const TitleView = require('balus/ui/view/body/data-content/title');
const ToolbarView = require('balus/ui/view/body/data-content/toolbar/index');
const NavView = require('balus/ui/view/body/data-content/nav/index');
const CanvasView = require('balus/ui/view/body/data-content/content/index');
const TaskCollectionRepository = require('communication/domain/repository/task-collection');
const TaskRelatedListView = require('communication/ui/view/task/related-list');
const TimelineView = require('balus/ui/view/timeline/index');
const AdditionalView = require('balus/ui/view/additional/index');

module.exports = Mn.View.extend({
    className: 'row',
    template: ContentTemplate,
    regions: {
        nav: '#nav',
        cover: '#cover',
        title: '#title',
        toolbar: '#toolbar',
        content: '#content',
        sidebar: '#sidebar'
    },

    onRender: function() {
        const project = this.getOption('context').getProject();
        this.showChildView('cover', new CoverView({
            model: project,
            context: this.getOption('context').getParent(),
            dataContent: true
        }));

        this.showChildView('title', new TitleView({
            model: this.model,
            context: this.getOption('context')
        }));

        this.showChildView('toolbar', new ToolbarView({
            model: this.model,
            context: this.getOption('context')
        }));

        this.showChildView('nav', new NavView({
            model: project,
            context: this.getOption('context').getParent(),
            content: this.model,
            showContent: true
        }));

        Promise.all([
            CommentCollectionRepository.find(project).byKey(this.model.key).fetchFirstPage(),
            TaskCollectionRepository.find(project).byKey(this.model.key).fetchFirstPage()
        ])
            .then(values => {
                const comments = values[0];
                const tasks = values[1];
                const content = this.getOption('context').getDataContent();
                const contentVersion = content.getLatestVersion();
                const contentKey = new Key(content.get('key'));
                const contentVersionKey = new Key(contentVersion.get('key'));
                const relatedKeys = new RelatedKeys([contentKey, contentVersionKey]);
                const navs = new SidebarCollection(
                    [
                        {
                            name: 'timeline',
                            icon: 'fa fa-comments-o',
                            label: 'module/word:timeline',
                            header: i18n.t('balus_template_body_data-content:sidebar.timeline-title', {name: this.model.getName(), interpolation: { escapeValue: false }}),
                            view: new TimelineView({
                                model: this.model,
                                collection: comments,
                                context: this.getOption('context'),
                                onCommentActivate: () => {
                                    this.getChildView('sidebar').activate('timeline');
                                },
                            }),
                            badge: {
                                content: function(){
                                    return comments.getTotalCount();
                                },
                                listen: function(onChange){
                                    comments.on('change:totalCount', onChange);
                                }
                            },
                            open: true
                        },
                        {
                            name: 'task',
                            icon: 'fa fa-check-square',
                            label: 'module/word:task',
                            header: i18n.t('balus_template_body_data-content:sidebar.timeline-title', {name: this.model.getName(), interpolation: { escapeValue: false }}),
                            view: new TaskRelatedListView({
                                collection: tasks,
                                context: this.getOption('context'),
                                AdditionalView: AdditionalView,
                                relatedKeys: relatedKeys
                            }),
                            badge: {
                                content: function(){
                                    return tasks.getTotalCount();
                                },
                                hasUnread: function() {
                                    return tasks.hasUnfinishedTask();
                                },
                                listen: function(onChange){
                                    tasks.on('change:totalCount', onChange);
                                    tasks.on('change:update', onChange);
                                }
                            }
                        }
                    ]
                );

                this.showChildView('content', new CanvasView({
                    model: this.model,
                    context: this.getOption('context')
                }));

                this.showChildView('sidebar', new SidebarView({
                    navs: navs,
                    horizontalNav: true
                }));

                this.getChildView('toolbar').renderNav(navs);

                const activateComment = () => {
                    const commentTimelineView = this.getChildView('sidebar').getView('timeline');
                    commentTimelineView.activateByHashState();
                };
                activateComment();
                window.addEventListener('hashchange', activateComment, false);
                this.on('destroy', () => {
                    window.removeEventListener('hashchange', activateComment, false);
                });
            });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/data-content/index.js